// SareaBlock.js

import {
    defineComponent,
    computed,
    inject,
    ref,
    watch,
    nextTick
} from "/Scripts/vue.esm-browser.js";
import { getTextWithoutSign } from "/Scripts/tools.js";
import { scrollService } from "/Services/Shop/scrollService.js";
const html = String.raw;

export default defineComponent({
    name: "SareaBlock",
    props: {
        pagedData: {
            type: Array,
            default: []
        }
    },
    setup(props, { emit }) {
        const selectedIndex = ref(-1);
        // 使用統一的選擇器對象進行元素查找
        const selectors = {
            area: {
                attr: () =>
                    "data-location-name",
                getTarget: (idx) => props.pagedData[idx].subArea,
            },
            location: {
                attr: "data-location-name",
                getTarget: (idx) => selectedArea.value.areas[idx].name,
            },
            theme: {
                attr: "data-theme-name",
                getTarget: (idx, currentLocation) =>
                    getTextWithoutSign(currentLocation.areas[idx].name),
            },
        };
        const sareaData = computed(() => {
            return props.pagedData.flatMap(item => item.subArea || []);
        });


        // 設置區域索引
        const setIndex = (idx, isClick = false) => {
            scrollService.setIndexWithScroll(selectedIndex, idx, isClick, {
                type: "area",
                params: {
                    target: selectors.area.getTarget(idx),
                    attr: selectors.area.attr(),
                },
            });
        };


        return {
            sareaData,
            setIndex
        };
    },
    mounted() {
        nextTick(() => {
            window.fitty('.textfit', {
                minSize: 8,
                maxSize: 16,
            });
        });
    },

    template: html`
        <div class="SEARA_block">
            <ul class="SEARA_list">
                <li class="fit-text-block" v-for="(sarea,idx) in sareaData" @click="setIndex(idx, true);">
                    <span
                        class="textfit"
                        style="white-space: nowrap; display: inline-block; font-size: 16px;"
                    >
                        {{getTextWithoutSign(sarea)}}
                    </span>
                </li>
            </ul>
        </div>
    `,
    methods: {
        getTextWithoutSign(text) {
            return getTextWithoutSign(text);
        },
    },
});
